import { combineReducers } from 'redux'

import drawingState from './drawingState'
import buttonState from './buttonState'

export default combineReducers({
  drawingState,
  buttonState,
})
